module.exports = __webpack_public_path__ + "img/cooperativeMedia10.3d89f72c.png";